import { UPDATE_HOME } from "../constants";
import { fetchHomePageData, fetchSliderData } from "../../services/strapiService";

// Action to fetch home data from Strapi
export const fetchHomeDataFromStrapi = (locale) => {
  return async (dispatch) => {
    try {
      // Fetch both home page data and slider data
      const [homeResponse, sliderResponse] = await Promise.all([
        fetchHomePageData(locale),
        fetchSliderData(locale)
      ]);

      // Get the Strapi URL from environment or use default
      const strapiUrl = process.env.REACT_APP_STRAPI_URL || 'http://156.67.104.166:1338';

      // Transform the Strapi response to match the expected format
      const transformedData = transformStrapiHomeData(
        homeResponse?.ok ? homeResponse.data : null,
        sliderResponse?.ok ? sliderResponse.data : [],
        strapiUrl
      );
      if (!homeResponse?.ok && homeResponse?.reason !== "NOT_FOUND") {
        console.warn("Home data unavailable:", homeResponse);
      }
      if (!sliderResponse?.ok && sliderResponse?.reason !== "NOT_FOUND") {
        console.warn("Slider data unavailable:", sliderResponse);
      }

      dispatch({
        type: UPDATE_HOME,
        data: transformedData,
      });
      return transformedData;
    } catch (error) {
      console.error("Error fetching home data from Strapi:", error);
      return null;
    }
  };
};

// Function to transform Strapi data to match the expected format
const transformStrapiHomeData = (homeResponse, sliderResponse, strapiUrl = 'http://156.67.104.166:1338') => {
  if (!homeResponse) {
    return null;
  }

  const homeData = homeResponse;

  // Process slider data if available
  let sliderData = [];
  if (sliderResponse && Array.isArray(sliderResponse)) {
    sliderData = sliderResponse.map(sliderItem => {
      // Use the large image format if available, otherwise use the main image URL
      const imageUrl = sliderItem.Image?.formats?.large?.url || sliderItem.Image?.url || '';
      // Prepend the API URL if the image URL is relative
      const fullImageUrl = !imageUrl.startsWith('http') ? `${strapiUrl}${imageUrl}` : imageUrl;

      return {
        id: sliderItem.id,
        title: sliderItem.textSlider || sliderItem.name || '',
        description: sliderItem.content || '',
        image: fullImageUrl,
        link: sliderItem.link,
        alt: sliderItem.name || `Slider ${sliderItem.id}`,
        color: sliderItem.color || '#ffffff',
        valeurInitiale: sliderItem.valeurInitiale || ''
      };
    });
  }

  // Process product presentation data
  let processedProductPresentation = [];
  if (homeData.productPresentation && Array.isArray(homeData.productPresentation)) {
    processedProductPresentation = homeData.productPresentation.map(item => {
      // Use the large image format if available, otherwise use the main image URL
      const imageUrl = item.image?.formats?.large?.url || item.image?.url || '';
      // Prepend the API URL if the image URL is relative
      const fullImageUrl = !imageUrl.startsWith('http') ? `${strapiUrl}${imageUrl}` : imageUrl;

      return {
        ...item,
        image: {
          ...item.image,
          url: fullImageUrl,
          formats: {
            ...item.image?.formats,
            large: {
              ...item.image?.formats?.large,
              url: fullImageUrl
            }
          }
        }
      };
    });
  }

  // Process block2 data to ensure proper image URL formatting
  let processedBlock2 = null;
  if (homeData.block2) {
    // Check if block2 is an object with numeric keys (like {"0": {...}, "1": {...}})
    // or if it's already an array
    if (typeof homeData.block2 === 'object' && !Array.isArray(homeData.block2)) {
      // Convert object with numeric keys to array
      const block2Array = Object.keys(homeData.block2).map(key => homeData.block2[key]);

      // Process each item in the array
      processedBlock2 = block2Array.map(item => {
        // Process image
        let processedImage = item.image;
        if (item.image && typeof item.image === 'object') {
          const imageUrl = item.image.formats?.large?.url ||
                         item.image.formats?.medium?.url ||
                         item.image.formats?.small?.url ||
                         item.image.url || '';
          const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

          processedImage = {
            ...item.image,
            url: fullImageUrl,
            formats: {
              ...item.image.formats,
              large: item.image.formats?.large ? {
                ...item.image.formats.large,
                url: fullImageUrl
              } : { url: fullImageUrl }
            }
          };
        }

        // Process icon
        let processedIcon = item.icon;
        if (item.icon && typeof item.icon === 'object') {
          const iconUrl = item.icon.url || '';
          const fullIconUrl = iconUrl.startsWith('/') ? `${strapiUrl}${iconUrl}` : iconUrl;

          processedIcon = {
            ...item.icon,
            url: fullIconUrl
          };
        }

        return {
          ...item,
          image: processedImage,
          icon: processedIcon
        };
      });
    } else if (Array.isArray(homeData.block2)) {
      // If it's already an array, process each item
      processedBlock2 = homeData.block2.map(item => {
        // Process image
        let processedImage = item.image;
        if (item.image && typeof item.image === 'object') {
          const imageUrl = item.image.formats?.large?.url ||
                         item.image.formats?.medium?.url ||
                         item.image.formats?.small?.url ||
                         item.image.url || '';
          const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

          processedImage = {
            ...item.image,
            url: fullImageUrl,
            formats: {
              ...item.image.formats,
              large: item.image.formats?.large ? {
                ...item.image.formats.large,
                url: fullImageUrl
              } : { url: fullImageUrl }
            }
          };
        }

        // Process icon
        let processedIcon = item.icon;
        if (item.icon && typeof item.icon === 'object') {
          const iconUrl = item.icon.url || '';
          const fullIconUrl = iconUrl.startsWith('/') ? `${strapiUrl}${iconUrl}` : iconUrl;

          processedIcon = {
            ...item.icon,
            url: fullIconUrl
          };
        }

        return {
          ...item,
          image: processedImage,
          icon: processedIcon
        };
      });
    } else {
      // If it's a single object, process it as before
      const block2Image = homeData.block2.image;
      const block2Icon = homeData.block2.icon;

      // Process block2 image
      let processedBlock2Image = block2Image;
      if (block2Image && typeof block2Image === 'object') {
        const block2ImageUrl = block2Image.formats?.large?.url ||
                             block2Image.formats?.medium?.url ||
                             block2Image.formats?.small?.url ||
                             block2Image.url || '';
        const fullBlock2ImageUrl = block2ImageUrl.startsWith('/') ? `${strapiUrl}${block2ImageUrl}` : block2ImageUrl;

        processedBlock2Image = {
          ...block2Image,
          url: fullBlock2ImageUrl,
          formats: {
            ...block2Image.formats,
            large: block2Image.formats?.large ? {
              ...block2Image.formats.large,
              url: fullBlock2ImageUrl
            } : { url: fullBlock2ImageUrl }
          }
        };
      }

      // Process block2 icon
      let processedBlock2Icon = block2Icon;
      if (block2Icon && typeof block2Icon === 'object') {
        const block2IconUrl = block2Icon.url || '';
        const fullBlock2IconUrl = block2IconUrl.startsWith('/') ? `${strapiUrl}${block2IconUrl}` : block2IconUrl;

        processedBlock2Icon = {
          ...block2Icon,
          url: fullBlock2IconUrl
        };
      }

      processedBlock2 = {
        ...homeData.block2,
        image: processedBlock2Image,
        icon: processedBlock2Icon
      };
    }
  }

  // Process block1 data to ensure proper image URL formatting
  let processedBlock1 = [];
  if (homeData.block1 && Array.isArray(homeData.block1)) {
    processedBlock1 = homeData.block1.map(item => {
      // Process image
      let processedImage = item.image;
      if (item.image && typeof item.image === 'object') {
        const imageUrl = item.image.formats?.large?.url ||
                        item.image.formats?.medium?.url ||
                        item.image.formats?.small?.url ||
                        item.image.url || '';
        const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

        processedImage = {
          ...item.image,
          url: fullImageUrl,
          formats: {
            ...item.image.formats,
            large: item.image.formats?.large ? {
              ...item.image.formats.large,
              url: fullImageUrl
            } : { url: fullImageUrl }
          }
        };
      }

      // Process icon
      let processedIcon = item.icon;
      if (item.icon && typeof item.icon === 'object') {
        const iconUrl = item.icon.url || '';
        const fullIconUrl = iconUrl.startsWith('/') ? `${strapiUrl}${iconUrl}` : iconUrl;

        processedIcon = {
          ...item.icon,
          url: fullIconUrl
        };
      }

      return {
        ...item,
        image: processedImage,
        icon: processedIcon
      };
    });
  }

  // Process aboutSection data to ensure proper image URL formatting
  let processedAboutSection = null;
  if (homeData.aboutSection && typeof homeData.aboutSection === 'object' && !Array.isArray(homeData.aboutSection)) {
    const item = homeData.aboutSection;

    // Process image
    let processedImage = item.image;
    if (item.image && typeof item.image === 'object') {
      const imageUrl = item.image.formats?.large?.url ||
                     item.image.formats?.medium?.url ||
                     item.image.formats?.small?.url ||
                     item.image.url || '';
      const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

      processedImage = {
        ...item.image,
        url: fullImageUrl,
        formats: {
          ...item.image.formats,
          large: item.image.formats?.large ? {
            ...item.image.formats.large,
            url: fullImageUrl
          } : { url: fullImageUrl }
        }
      };
    }

    // Process values
    let processedValues = item.values || [];
    if (item.values && Array.isArray(item.values)) {
      processedValues = item.values.map(value => {
        if (typeof value === 'object' && value !== null) {
          return {
            id: value.id,
            name: value.name || '',
            description: value.description || ''
          };
        }
        return value;
      });
    }

    processedAboutSection = {
      ...item,
      image: processedImage,
      values: processedValues
    };
  }

  // Process productPortfolioSection data to ensure proper image URL formatting
  let processedProductPortfolioSection = null;
  if (homeData.productPortfolioSection && typeof homeData.productPortfolioSection === 'object' && !Array.isArray(homeData.productPortfolioSection)) {
    const item = homeData.productPortfolioSection;

    // Process categories
    let processedCategories = [];
    if (item.categories && Array.isArray(item.categories)) {
      processedCategories = item.categories.map(category => {
        // Process icon
        let processedIcon = category.icon;
        if (category.icon && typeof category.icon === 'object') {
          const iconUrl = category.icon.formats?.thumbnail?.url ||
                         category.icon.formats?.small?.url ||
                         category.icon.formats?.medium?.url ||
                         category.icon.formats?.large?.url ||
                         category.icon.url || '';
          const fullIconUrl = iconUrl.startsWith('/') ? `${strapiUrl}${iconUrl}` : iconUrl;

          processedIcon = {
            ...category.icon,
            url: fullIconUrl
          };
        }

        // Process image
        let processedImage = category.image;
        if (category.image && typeof category.image === 'object') {
          const imageUrl = category.image.formats?.large?.url ||
                         category.image.formats?.medium?.url ||
                         category.image.formats?.small?.url ||
                         category.image.url || '';
          const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

          processedImage = {
            ...category.image,
            url: fullImageUrl
          };
        }

        // Process products
        let processedProducts = [];
        if (category.products && Array.isArray(category.products)) {
          processedProducts = category.products.map(product => {
            // Process product image
            let processedProductImage = product.image;
            if (product.image && typeof product.image === 'object') {
              const productImageUrl = product.image.formats?.large?.url ||
                                    product.image.formats?.medium?.url ||
                                    product.image.formats?.small?.url ||
                                    product.image.url || '';
              const fullProductImageUrl = productImageUrl.startsWith('/') ? `${strapiUrl}${productImageUrl}` : productImageUrl;

              processedProductImage = {
                ...product.image,
                url: fullProductImageUrl
              };
            }

            return {
              ...product,
              productImage: processedProductImage // Renommer image en productImage pour correspondre au composant
            };
          });
        }

        return {
          ...category,
          icon: processedIcon,
          imageUrl: processedImage?.url, // Utiliser imageUrl pour correspondre au composant
          products: processedProducts
        };
      });
    }

    processedProductPortfolioSection = {
      ...item,
      categories: processedCategories
    };
  }

  // Process geographicPresenceSection data to ensure proper image URL formatting
  let processedGeographicPresenceSection = null;
  if (homeData.geographicPresenceSection && typeof homeData.geographicPresenceSection === 'object' && !Array.isArray(homeData.geographicPresenceSection)) {
    const item = homeData.geographicPresenceSection;

    // Process map image
    let processedMapImage = item.mapImage;
    if (item.mapImage && typeof item.mapImage === 'object') {
      const mapImageUrl = item.mapImage.formats?.large?.url ||
                         item.mapImage.formats?.medium?.url ||
                         item.mapImage.formats?.small?.url ||
                         item.mapImage.formats?.thumbnail?.url ||
                         item.mapImage.url || '';
      const fullMapImageUrl = mapImageUrl.startsWith('/') ? `${strapiUrl}${mapImageUrl}` : mapImageUrl;

      processedMapImage = {
        ...item.mapImage,
        url: fullMapImageUrl
      };
    }

    // Process countries
    let processedCountries = [];
    if (item.countries && Array.isArray(item.countries)) {
      processedCountries = item.countries.map(country => ({
        ...country
      }));
    }

    // Process additional projects
    let processedAdditionalProjects = [];
    if (item.additionalProjects && Array.isArray(item.additionalProjects)) {
      processedAdditionalProjects = item.additionalProjects.map(project => ({
        ...project
      }));
    }

    processedGeographicPresenceSection = {
      ...item,
      mapImage: processedMapImage,
      countries: processedCountries,
      additionalProjects: processedAdditionalProjects
    };
  }

  // Process excellenceCenterSection data to ensure proper image URL formatting
  let processedExcellenceCenterSection = null;
  if (homeData.excellenceCenterSection && typeof homeData.excellenceCenterSection === 'object' && !Array.isArray(homeData.excellenceCenterSection)) {
    const item = homeData.excellenceCenterSection;

    // Process image
    let processedImage = item.image;
    if (item.image && typeof item.image === 'object') {
      const imageUrl = item.image.formats?.large?.url ||
                     item.image.formats?.medium?.url ||
                     item.image.formats?.small?.url ||
                     item.image.formats?.thumbnail?.url ||
                     item.image.url || '';
      const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

      processedImage = {
        ...item.image,
        url: fullImageUrl
      };
    }

    // Process focus areas
    let processedFocusAreas = [];
    if (item.focusAreas && Array.isArray(item.focusAreas)) {
      processedFocusAreas = item.focusAreas.map(area => ({
        ...area
      }));
    }

    // Process university partners
    let processedUniversityPartners = [];
    if (item.universityPartners && Array.isArray(item.universityPartners)) {
      processedUniversityPartners = item.universityPartners.map(partner => ({
        ...partner
      }));
    }

    processedExcellenceCenterSection = {
      ...item,
      image: processedImage,
      focusAreas: processedFocusAreas,
      universityPartners: processedUniversityPartners
    };
  }

  // Process caseStudiesSection data to ensure proper image URL formatting
  let processedCaseStudiesSection = null;
  if (homeData.caseStudiesSection && typeof homeData.caseStudiesSection === 'object' && !Array.isArray(homeData.caseStudiesSection)) {
    const item = homeData.caseStudiesSection;

    // Process studies
    let processedStudies = [];
    if (item.studies && Array.isArray(item.studies)) {
      processedStudies = item.studies.map(study => {
        // Process image
        let processedImage = study.image;
        if (study.image && typeof study.image === 'object') {
          const imageUrl = study.image.formats?.large?.url ||
                         study.image.formats?.medium?.url ||
                         study.image.formats?.small?.url ||
                         study.image.formats?.thumbnail?.url ||
                         study.image.url || '';
          const fullImageUrl = imageUrl.startsWith('/') ? `${strapiUrl}${imageUrl}` : imageUrl;

          processedImage = {
            ...study.image,
            url: fullImageUrl
          };
        }

        // Process challenges
        let processedChallenges = [];
        if (study.challenges && Array.isArray(study.challenges)) {
          processedChallenges = study.challenges.map(challenge => ({
            ...challenge
          })).filter(challenge => challenge.name); // Filter out empty challenges
        }

        // Process benefits
        let processedBenefits = [];
        if (study.benefits && Array.isArray(study.benefits)) {
          processedBenefits = study.benefits.map(benefit => ({
            ...benefit
          })).filter(benefit => benefit.name); // Filter out empty benefits
        }

        return {
          ...study,
          image: processedImage,
          challenges: processedChallenges,
          benefits: processedBenefits
        };
      });
    }

    processedCaseStudiesSection = {
      ...item,
      studies: processedStudies
    };
  }

  // Process careersSection data to ensure proper image URL formatting
  let processedCareersSection = null;
  if (homeData.careersSection && typeof homeData.careersSection === 'object' && !Array.isArray(homeData.careersSection)) {
    const item = homeData.careersSection;

    // Process team image
    let processedTeamImage = item.teamImage;
    if (item.teamImage && typeof item.teamImage === 'object') {
      const teamImageUrl = item.teamImage.url || '';
      const fullTeamImageUrl = teamImageUrl.startsWith('/') ? `${strapiUrl}${teamImageUrl}` : teamImageUrl;

      processedTeamImage = {
        ...item.teamImage,
        url: fullTeamImageUrl
      };
    }

    // Process benefits
    let processedBenefits = [];
    if (item.benefits && Array.isArray(item.benefits)) {
      processedBenefits = item.benefits.map(benefit => ({
        ...benefit
      }));
    }

    // Process locations
    let processedLocations = [];
    if (item.locations && Array.isArray(item.locations)) {
      processedLocations = item.locations;
    }

    processedCareersSection = {
      ...item,
      teamImage: processedTeamImage,
      benefits: processedBenefits,
      locations: processedLocations
    };
  }

  // Process directorMessage data
  let processedDirectorMessage = null;
  const source = homeData.DirectorMessage || homeData.directorMessage;

  if (source) {
    const item = source;
    const rawImage = item.image?.data?.attributes || item.image;
    let processedImage = null;

    if (rawImage) {
      const imgUrl = rawImage.url || "";
      const fullUrl = imgUrl.startsWith('/') ? `${strapiUrl}${imgUrl}` : imgUrl;
      processedImage = { ...rawImage, url: fullUrl };
    }

    processedDirectorMessage = {
      ...item,
      image: processedImage
    };
  }

  // Extract the relevant data from Strapi response
  return {
    id: homeData.id,
    documentId: homeData.documentId,
    createdAt: homeData.createdAt,
    updatedAt: homeData.updatedAt,
    publishedAt: homeData.publishedAt,
    locale: homeData.locale,
    productPresentation: processedProductPresentation,
    statsSection: homeData.statsSection || [],
    block1: processedBlock1,
    block2: processedBlock2,
    blogs: homeData.blogs || [],
    news: homeData.news || null,
    meta: homeData.meta || null,
    sliders: sliderData, // Add slider data to the response
    aboutSection: processedAboutSection, // Add aboutSection data to the response
    productPortfolioSection: processedProductPortfolioSection, // Add productPortfolioSection data to the response
    geographicPresenceSection: processedGeographicPresenceSection, // Add geographicPresenceSection data to the response
    excellenceCenterSection: processedExcellenceCenterSection, // Add excellenceCenterSection data to the response
    caseStudiesSection: processedCaseStudiesSection, // Add caseStudiesSection data to the response
    careersSection: processedCareersSection, // Add careersSection data to the response
    directorMessage: processedDirectorMessage, // Add directorMessage data to the response
    // Add any other fields that might be needed
  };
};

export const setHomeData = (data) => ({
  type: UPDATE_HOME,
  data,
});

export const home = (state = null, action) => {
  switch (action.type) {
    case UPDATE_HOME:
      return action.data;
    default:
      return state;
  }
};
